function showDetails() {
    var anonymousRadio = document.getElementById('anonymous');
    var feedbackRadio = document.getElementById('feedback');
    var personalDetails = document.querySelector('.footer-personal-details');

    if (!anonymousRadio || !feedbackRadio || !personalDetails) {
        return;
    }
    function updateDisplay() {
        if (feedbackRadio.checked) {
            personalDetails.style.display = 'flex';
        } else {
            personalDetails.style.display = 'none';
        }
    }

    feedbackRadio.addEventListener('change', updateDisplay);
    anonymousRadio.addEventListener('change', updateDisplay);

    updateDisplay();
}

document.addEventListener("DOMContentLoaded", () => {
    showDetails();
});


// WEBPACK FOOTER //
// ./Components/Shared/footer.js